module.exports = __webpack_public_path__ + "img/nevi_teaser_mobile_why_electrify.351e53dd.png";